export default defineNuxtPlugin(async nuxtApp => {
	if (nuxtApp.$isbot) return;

	const config = useAppConfig();
	const token = useToken();
	const auth = useAuth();
	const webshop = useWebshop();
	const {fetchRedirects, getRedirects, setRedirects} = useRedirects();

	if (!token.get()) {
		await token.generate();
	}

	const tasks = [];

	// fetch redirects
	if (!getRedirects()?.length) {
		tasks.push(fetchRedirects().then(redirects => setRedirects(redirects?.data)));
	}

	// Fetch abandonment data
	if (nuxtApp._route.query.abandonment && nuxtApp._route.query.saveconfirm) {
		tasks.push(
			webshop.fetchAbandonment({
				abandonment: nuxtApp._route.query.abandonment,
				saveconfirm: nuxtApp._route.query.saveconfirm,
			})
		);
	}

	// Handle user authentication
	if (__AUTH__) {
		const authTask = auth
			.fetchIsLogin()
			.then(async isLoggedin => {
				if (isLoggedin?.user_id) {
					await auth.fetchUser();
				}
			})
			.catch(e => {
				useLog(e);
			});
		tasks.push(authTask);
	}

	await Promise.all(tasks);
});
